import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import NewMotorcyclePage from "./pages/NewMotorcyclePage";
import MotorcycleListPage from "./pages/MotorcycleListPage";
import MotorcycleDetailPage from "./pages/MotorcycleDetailPage";
import SearchPage from "./pages/SearchPage";
import HistoryPage from "./pages/HistoryPage";
import TrackingPage from "./pages/TrackingPage";
import StoresPage from "./pages/StoresPage";
import TechniciansPage from "./pages/TechniciansPage";
import ChecklistTemplatesPage from "./pages/ChecklistTemplatesPage";
import RevisionPage from "./pages/RevisionPage";
import AdminPage from "./pages/AdminPage";
import CompanySettingsPage from "./pages/CompanySettingsPage";
import ClientsPage from "./pages/ClientsPage";
import RevisionsReportPage from "./pages/RevisionsReportPage";

function App() {
  return (
    <AuthProvider>
      <Toaster 
        position="top-center" 
        richColors 
        theme="dark"
        duration={3000}
        toastOptions={{
          style: {
            background: '#1A1A1A',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff'
          }
        }}
      />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/rastreio/:chassisSN" element={<TrackingPage />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/nova-moto" element={
            <ProtectedRoute>
              <NewMotorcyclePage />
            </ProtectedRoute>
          } />
          <Route path="/motos" element={
            <ProtectedRoute>
              <MotorcycleListPage />
            </ProtectedRoute>
          } />
          <Route path="/motos/:id" element={
            <ProtectedRoute>
              <MotorcycleDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/consulta" element={
            <ProtectedRoute>
              <SearchPage />
            </ProtectedRoute>
          } />
          <Route path="/historico" element={
            <ProtectedRoute>
              <HistoryPage />
            </ProtectedRoute>
          } />
          <Route path="/revisoes" element={
            <ProtectedRoute>
              <RevisionsReportPage />
            </ProtectedRoute>
          } />
          <Route path="/lojas" element={
            <ProtectedRoute>
              <StoresPage />
            </ProtectedRoute>
          } />
          <Route path="/tecnicos" element={
            <ProtectedRoute>
              <TechniciansPage />
            </ProtectedRoute>
          } />
          <Route path="/checklists" element={
            <ProtectedRoute>
              <ChecklistTemplatesPage />
            </ProtectedRoute>
          } />
          <Route path="/clientes" element={
            <ProtectedRoute>
              <ClientsPage />
            </ProtectedRoute>
          } />
          <Route path="/revisao/:id" element={
            <ProtectedRoute>
              <RevisionPage />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          } />
          <Route path="/configuracoes" element={
            <ProtectedRoute>
              <CompanySettingsPage />
            </ProtectedRoute>
          } />

          {/* Redirect root to dashboard or login */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* 404 - Redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
